var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Link, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { SMILESComponent } from "./SMILESComponent";
import { PrismLight as SyntaxHighlighter } from "react-syntax-highlighter";
import python from "react-syntax-highlighter/dist/esm/languages/prism/python";
import prism from "react-syntax-highlighter/dist/esm/styles/prism/okaidia";
import { PythonCodeComponent } from "./PythonCodeComponent";
SyntaxHighlighter.registerLanguage("python", python);
export function MarkdownWrapper({ children, handleLoadSMILES, completing, }) {
    const theme = useTheme();
    return (_jsx(ReactMarkdown, Object.assign({ remarkPlugins: [remarkGfm], components: {
            a: (_a) => {
                var _b, _c;
                var { node } = _a, props = __rest(_a, ["node"]);
                const href = props.href || "";
                if (href.startsWith("_custom?")) {
                    const urlParams = new URLSearchParams(href.split("?")[1]);
                    if (urlParams) {
                        const params = Object.fromEntries(urlParams.entries());
                        if (handleLoadSMILES && params["type"] === "smiles") {
                            let smiles;
                            //@ts-ignore
                            smiles = (_c = (_b = props.children) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.children;
                            if (smiles) {
                                const mol = window.RDKit.get_mol(smiles);
                                return (_jsx(SMILESComponent, { smiles: smiles, handleLoadSMILES: handleLoadSMILES, invalid: !mol || !mol.is_valid() }));
                            }
                        }
                    }
                }
                return (_jsx(Link, Object.assign({ href: props.href, target: "_blank", rel: "noopener", color: theme.palette.info.light }, { children: _jsx(_Fragment, { children: props.children }) })));
            },
            code(_a) {
                var { node, className, children } = _a, props = __rest(_a, ["node", "className", "children"]);
                const match = /language-(\w+)/.exec(className || "");
                const language = match ? match[1] : "";
                if (language === "python") {
                    const codeString = String(children).replace(/\n$/, "");
                    return (_jsx(SyntaxHighlighter, Object.assign({ children: codeString, style: prism, language: language, PreTag: "div", wrapLines: true, CodeTag: (props) => (_jsx(PythonCodeComponent, Object.assign({ codeString: codeString, disabled: completing }, { children: props.children }))) }, props)));
                }
                return (_jsx("code", Object.assign({ className: className }, props, { children: children })));
            },
            p: (_a) => {
                var { node } = _a, props = __rest(_a, ["node"]);
                return (_jsx(Typography, Object.assign({ variant: "body2" }, { children: props.children })));
            },
            ul: (_a) => {
                var { node } = _a, props = __rest(_a, ["node"]);
                return (_jsx("ul", Object.assign({ style: { margin: 0 } }, props, { children: props.children })));
            },
            ol: (_a) => {
                var { node } = _a, props = __rest(_a, ["node"]);
                return (_jsx("ol", Object.assign({ style: { margin: 0 } }, { children: props.children })));
            },
        } }, { children: children })));
}
